import { ContentType } from '@lightdash/common';
import { Center, SegmentedControl, Text } from '@mantine-8/core';
import { type FC } from 'react';

interface OptionProps {
    label: string;
    color?: string;
}

const ContentTypeSelectOption = ({ label }: OptionProps) => (
    <Center px={'xxs'}>
        <Text fz="sm" c="ldGray.7">
            {label}
        </Text>
    </Center>
);

const ContentTypeOptions = [
    {
        value: ContentType.DASHBOARD,
        label: <ContentTypeSelectOption label={'Dashboards'} />,
    },
    {
        value: ContentType.CHART,
        label: <ContentTypeSelectOption label={'Charts'} />,
    },
    {
        value: ContentType.DATA_APP,
        label: <ContentTypeSelectOption label={'Data Apps'} />,
    },
];
type ContentTypeFilterProps = {
    value: ContentType | undefined;
    onChange: (value: ContentType | undefined) => void;
    options: ContentType[];
};

const ContentTypeFilter: FC<ContentTypeFilterProps> = ({
    value,
    onChange,
    options,
}) => {
    return (
        <SegmentedControl
            size="xs"
            radius="md"
            value={value ?? 'all'}
            onChange={(newValue) =>
                onChange(
                    newValue === 'all' ? undefined : (newValue as ContentType),
                )
            }
            data={[
                {
                    value: 'all',
                    label: <ContentTypeSelectOption label={'All'} />,
                },
                ...ContentTypeOptions.filter((option) =>
                    options?.includes(option.value),
                ),
            ]}
        />
    );
};

export default ContentTypeFilter;
